<template>
  <div>
    <div class="lista-mesas container-fluid height-100 mb-0">
      <loading v-if="load"/>
      <div :class="load ? 'invisible' : 'visible'">
        <form @submit.prevent="novaMesa(mesa)" class="mx-auto" style="max-width: 600px">
          <div class="d-flex justify-content-between mb-2">
            <div class="p-1 w-100">
              <input id="refMesas" type="number" class="form-control" min="1" placeholder="Mesa" v-model="mesa" required>
            </div>
            <div class="p-1 text-nowrap">
              <div class="p-1 text-nowrap">
                <button class="btn btn-primary mr-1" title="Nova mesa" style="min-width: 56px">
                  <i class="fa fa-plus"></i><span class="d-none d-md-inline"> Nova Mesa</span>
                </button>
                <button class="btn btn-outline-secondary" type="button" @click="buscarVendas()" title="Atualizar vendas" style="min-width: 56px">
                  <i class="fa fa-sync-alt"></i><span class="d-none d-md-inline"> Atualizar</span>
                </button>
              </div>
            </div>
          </div>
        </form>
        <div class="text-center mt-2 mb-3">
          <i class="fa fa-circle text-success"></i> Mesa Disponível <span class="px-2">|</span> <i class="fa fa-circle text-secondary"></i> Mesa Ocupada
        </div>
        <div class="row no-gutters">
          <div class="col-4 col-sm-3 col-lg-2 p-1" v-for="m in mesas">
            <a :class="m.vendas.length ? 'btn-secondary' : 'btn-success'" class="btn btn-block text-left py-3" href="javascript:" @click="selecionarMesa(m)">
              <div class="badge badge-clock" v-if="m.vendas.length" title="Tempo que foi aberta">
                <i class="fa fa-clock"></i> <clock :time="m.tempo" live="true"/>
              </div>
              <h5 class="mb-0 text-ellipsis font-weight-bold">{{m.numero}}</h5>
              <div class="small" v-if="!m.vendas.length">Disponível</div>
              <div class="text-ellipsis small" :title="m.observacao" v-else>
                {{ m.nome_cliente || m.observacao || 'Ocupada' }}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-pdv modal-small show" tabindex="-1" v-if="modal">
      <div class="modal-pdv-content">
        <div class="container-fluid px-3">
          <modal-menu :menus="menus" :selected="menu" @changeMenu="toggleMenu" class="mb-0" v-show="menu < 3"/>
          <div :class="menu === 3 ? 'height-100' : 'height-95'">
            <div v-if="menu === 1 && comandas.length">
              <div class="row no-gutters">
                <div class="col-4 col-md-6 p-1" v-for="c in comandas">
                  <a :class="c.id_comanda ? 'btn-secondary' : 'btn-info'" class="btn btn-block text-left py-3" href="javascript:" @click="selecionarComanda(c)">
                    <h5 class="mb-0 text-ellipsis font-weight-bold">{{c.ref_comanda || c.mesa}}</h5>
                    <div class="text-ellipsis small" :title="c.observacao">{{!c.ref_comanda ? (c.nome_cliente || 'Mesa') : (c.observacao || 'Comanda')}}</div>
                  </a>
                </div>
                <div class="col-4 col-md-6 p-1">
                  <a href="javascript:" class="btn btn-block text-left py-3 btn-outline-dark" @click="selecionarMesa({ numero: comandas[0].mesa, vendas: [] })">
                    <i class="fa fa-plus mr-1"></i>
                    <div class="small">Nova Comanda</div>
                  </a>
                </div>
              </div>
            </div>
            <div v-if="menu === 2">
              <div v-if="loadModal">
                <loading/>
                <div v-if="selecionados.length" class="text-center mt-1">Imprimindo pedidos. Aguarde..</div>
              </div>
              <table class="table small mb-0" v-else>
                <tr>
                  <th class="border-top-0" style="width: 36px">
                    <input type="checkbox" class="ml-2" @change="selTodos" :checked="selecionados.length === pedidos.length">
                  </th>
                  <th class="border-top-0 pointer" @click="selTodos">Selecionar todos</th>
                  <th class="border-top-0">&nbsp;</th>
                </tr>
                <tr v-for="p in pedidos">
                  <td>
                    <input type="checkbox" :id="p.id_pedido" class="ml-2" :value="p" v-model="selecionados">
                  </td>
                  <td class="align-middle">
                    <label :for="p.id_pedido" class="pointer mb-0">
                      Pedido: {{p.pedido}} <br> Horário: {{p.data_pedido}} | Comanda: {{p.ref_comanda}}
                    </label>
                  </td>
                  <td class="align-middle text-right">
                    <button class="btn btn-outline-dark btn-sm" title="Visualizar Pedido" @click="visualizarPedido(p)"><i class="fa fa-eye"></i></button>
                  </td>
                </tr>
              </table>
            </div>
            <div class="pt-3" v-show="menu === 3">
              <cupom-pedido :pedido="pedido" :id="'cupomMerge'" show="true"/>
            </div>
          </div>
        </div>
        <div class="modal-content-footer bg-light border-top p-2 mt-3 d-flex justify-content-between">
          <button class="btn btn-dark p-3" @click="closeModal()">
            <i class="fa fa-chevron-left mr-2"></i>
            <span>Voltar</span>
          </button>
          <button class="btn btn-success p-3" @click="imprimirPedidos(0)" v-if="menu === 2 && selecionados.length" :disabled="loadModal">
            <i class="fa fa-print mr-2"></i>
            <span class="small">Imprimir</span>
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Loading from "../../../components/commons/Loading";
  import ModalMenu from "@/components/commons/ModalMenu";
  import CupomPedido from "@/views/comanda/pdv/CupomPedido";
  import Clock from "@/components/commons/Clock";

  export default {
    name: 'MesasComandas',
    components: {Clock, CupomPedido, ModalMenu, Loading},
    data() {
      return {
        token: localStorage.getItem('key'),
        modal: false,
        load: false,
        mesa: '',
        mesas: [],
        comandas: [],
        menus: [{ nome: 'Comandas', active: true }, { nome: 'Pedidos', active: true }],
        menu: 1,

        pedidos: [],
        selecionados: [],
        pedido: null,
        loadModal: false
      }
    },

    methods: {
      buscarVendas(notLoad) {
        if (this.load) {
          return;
        }

        this.load = !notLoad;

        this.$http.get('comandas/mesas/' + this.token, {params: { tipo: 1 }})
          .then(response => {
            this.mesas = [];
            let vendas = response.data || [];

            if (!this.load) {
              this.mesas = [];
            }

            for (let i=1; i <= this.qtd_mesas; i++) {
              let bds = vendas.filter(c => parseInt(c.mesa) === i);
              this.mesas.push({ ...(bds.length === 1 ? bds[0] : {}), numero: (i < 10 ? '0' : '') + i, vendas: bds, tempo: (bds.length ? bds[0].tempo : 0) });
              vendas = vendas.filter(c => parseInt(c.mesa) !== i);
            }

            if (vendas.length) {
              let extras = [];
              vendas = vendas.sort((a, b) => a.mesa > b.mesa ? 1 : -1);
              vendas.forEach(m => { extras.push({ ...m, numero: m.mesa, vendas: [m] }) });
              this.mesas.splice(this.mesas.length, 0, ...extras);
            }

            this.load = false;
            this.$nextTick(() => {
              this.$helpers.focusElement('refMesas');
            });

          }, res => {
            this.mesas = [];
            this.load = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      novaMesa(mesa) {
        let numero = parseInt(mesa);

        if (numero < 0 || numero > 10000) {
          this.$swal('Por favor, informe um número de mesa válido').then(() => {
            this.$helpers.focusElement('refMesas');
          });

          return;
        }

        this.selecionarMesa(this.mesas.find(c => c.mesa == numero) || { numero, vendas: [] });
      },

      selecionarMesa(mesa) {
        let url = '/pdv/';

        if (mesa.vendas.length && (mesa.vendas.length > 1 || mesa.vendas[0].ref_comanda)) {
          this.menus[1].active = mesa.vendas.length > 1;
          this.comandas = mesa.vendas.sort((a, b) => parseInt(a.ref_comanda) < parseInt(b.ref_comanda) ? -1 : 1);
          this.openModal();
          return;

        } else if (mesa.vendas.length === 1) {
          url += mesa.vendas[0].id_comanda;

        } else {
          url += 'mesa/' + mesa.numero;
        }

        if (this.$route.path !== url) {
          this.$router.push(url);

        } else if (mesa.vendas.length) {
          this.$emit('atualizar');
        }

        this.$emit('openMesa');
      },

      selecionarComanda(comanda) {
        let url = '/pdv/' + comanda.id_comanda;

        if (this.$route.path !== url) {
          this.$router.push(url);

        } else {
          this.$emit('atualizar');
        }

        this.$emit('openMesa');
      },

      openModal() {
        this.menu = 1;
        this.pedidos = [];
        this.selecionados = [];
        this.modal = true;
      },

      toggleMenu(m) {
        this.menu = m;

        if (this.menu === 2 && !this.pedidos.length) {
          this.loadModal = true;
          this.$http.get('pdv/pedidos/' + this.token + '/?mesa=' + this.comandas[0].mesa)
            .then(response => {
              this.loadModal = false;
              this.pedidos = response.data || [];

            }, res => {
              this.loadModal = false;
              this.$swal(res.data.msg && res.data.msg ? res.data.msg : 'Erro Temporário');
            });
        }
      },

      closeModal() {
        if (this.menu === 3) {
          this.menu = 2;

        } else {
          this.pedido = null;
          this.modal = false;
        }
      },

      selTodos() {
        if (this.pedidos.length) {
          this.selecionados = (this.selecionados.length < this.pedidos.length) ? this.pedidos : [];
        }
      },

      imprimirPedidos(index) {
        this.loadModal = true;

        if (this.selecionados.length > index) {
          this.pedido = this.selecionados[index];
          this.$nextTick(() => {
            this.imprimir(index);
          });

        } else {
          this.loadModal = false;
          this.selecionados = [];
          this.closeModal();

          if (this.isElectron) {
            this.$swal('Impressão enviada com sucesso!');
          }
        }
      },

      imprimir(index) {
        let devices = this.pedido.cozinhas || null;

        if (devices && this.pedido.tipo_pedido !== '3') {
          devices = devices.map(c => { return { ...c, id_cozinha: null } });
        }

        this.$helpers.imprimirPedido(this, this.pedido.id_pedido, localStorage.getItem('token'), 'cupomMerge', devices, 1, () => {
          this.imprimirPedidos(index + 1);
        });
      },

      visualizarPedido(pedido) {
        this.pedido = pedido;
        this.menu = 3;
      }
    },

    mounted() {
      this.buscarVendas();
    },

    computed: {
      qtd_mesas() {
        return parseInt(this.$store.state.pdv.qtd_mesas)
      }
    },

    sockets: {
      comanda_order(data) {
        if (data && data.tipo_comanda === '1') {
          this.buscarVendas(true);
        }
      }
    }
  }
</script>

<style scoped>
.lista-mesas.height-100 {
  height: calc(100vh - 136px);
  padding: 18px 15px;
}

.btn .badge-clock {
  position: absolute;
  top: 14px;
  right: 11px;
}

@media (max-width: 767px) {
  .lista-mesas.height-100 {
    padding-bottom: 94px;
  }

  .btn .badge-clock {
    top: 10px;
    right: 11px;
    font-size: 0.7rem;
  }
}
</style>